// extracted by mini-css-extract-plugin
export default {"container":"field_list_container__MJCpJ","subLabel":"field_list_subLabel__ClvCr"};